import React, { FC } from 'react';
import { TemplateInsightGroupBy } from 'api/template-insight';
import { Filter } from 'components/molecules/filters/types';
import { DateRange } from 'components/organisms/projects-report/common/range-picker/types';
import { Wrapper } from '../components';
import { FrequentlyBlockedTask } from './frequently-blocked-task';
import { FrequentlyCompletedTable } from './frequently-completed-table';

export const AllTask: FC<{ range: DateRange; filter: Filter }> = ({
  range,
  filter,
}) => {
  return (
    <Wrapper>
      <FrequentlyCompletedTable
        groupBy={TemplateInsightGroupBy.TasksCompletedEarly}
        range={range}
        filter={filter}
      />
      <FrequentlyCompletedTable
        groupBy={TemplateInsightGroupBy.TasksCompletedLate}
        range={range}
        filter={filter}
      />
      <FrequentlyBlockedTask range={range} filter={filter} />
    </Wrapper>
  );
};
